const {
  // API
  REACT_APP_BASE_API: BASE_API,

  REACT_APP_AUTH_URL: AUTH_URL,
  REACT_APP_LOGOUT_URL: LOGOUT_URL,
  REACT_APP_AUTH_SCOPE: AUTH_SCOPE,
  REACT_APP_AUTH_CLIENT_ID: AUTH_CLIENT_ID,

  // MSW
  REACT_APP_MSW: MSW_ENABLED,

  // SENTRY
  REACT_APP_SENTRY_DSN: SENTRY_DSN,
  REACT_APP_SENTRY_ENVIRONMENT: SENTRY_ENVIRONMENT,

  REACT_APP_CLARITY_ID: CLARITY_ID,
} = process.env;

const ENABLE_SENTRY = SENTRY_ENVIRONMENT !== 'development';

export {
  AUTH_CLIENT_ID,
  AUTH_SCOPE,
  AUTH_URL,
  BASE_API,
  ENABLE_SENTRY,
  LOGOUT_URL,
  MSW_ENABLED,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  CLARITY_ID,
};
